import { cloneDeep, isNil } from "lodash";

import { DateFormatIdentifiers } from "../../constants/dateFormats";
import { TimeFormatIdentifiers } from "../../constants/timeFormats";
import { wasOldStyleGregorianCalendarFromCalendar } from "../../modules/definition/calendar/gregorianCalendar";
import { createFromJS } from "../../types";
import calendarTypes from "../../types/calendarTypes";

export default v2Calendar => {
  const calendar = cloneDeep(v2Calendar);

  switch (calendar.dateFormat) {
    case "short": {
      calendar.dateFormat = DateFormatIdentifiers.Short;
      break;
    }
    case "long": {
      calendar.dateFormat = DateFormatIdentifiers.Long;
      break;
    }
    default: {
      calendar.dateFormat = DateFormatIdentifiers.Medium;
      break;
    }
  }
  switch (calendar.timeFormat) {
    case "24":
      calendar.timeFormat = TimeFormatIdentifiers.TwentyFour;
      break;
    default:
      calendar.timeFormat = TimeFormatIdentifiers.Twelve;
      break;
  }

  switch (calendar.displayType) {
    case "Floating Week":
      calendar.calendarType = calendarTypes.CALENDAR_TYPE_WEEKDAY_TIME;
      break;
    case "Floating Day":
      calendar.calendarType = calendarTypes.CALENDAR_TYPE_DAY_TIME;
      break;
    case "Zero Hour":
      calendar.calendarType = calendarTypes.CALENDAR_TYPE_HOUR_TIME;
      break;
    default:
      calendar.calendarType = calendarTypes.CALENDAR_TYPE_DATE_TIME;
      break;
  }

  delete calendar.displayType;

  calendar.dateFormatIncludesDayName = isNil(calendar.dateFormatIncludeDayName)
    ? true
    : Boolean(calendar.dateFormatIncludeDayName);

  let updateDatesInBC = false;

  // If we are dealing with a Gregorian calendar of the old style, then we should
  // update the calendar to the correct Gregorian calendar with BC leap years
  const calendarRecord = createFromJS.CalendarRecord(calendar);
  if (wasOldStyleGregorianCalendarFromCalendar(calendarRecord)) {
    calendar.eras[0].hasLeapYears = true;
    calendar.eras[0].leapOffset = 1;
    updateDatesInBC = true;
  }

  return { updateDatesInBC, calendar };
};
